"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _default = {
  /* Fix NPEs in apps that were using these methods manually */
  componentWillMount: function componentWillMount() {},
  componentWillUnmount: function componentWillUnmount() {},
  partial: _partial.default
};
exports.default = _default;
module.exports = exports.default;